<template>
    <div class="board-list-faq">
        <v-expansion-panels accordion>
            <v-expansion-panel v-for="(faq, index) in faqs" :key="index">
                <v-expansion-panel-header>
                    <div class="d-flex align-center">
                        <v-avatar color="primary" size="32" class="mr-10px"><strong class="font-size-14 white--text mt-n2px">Q</strong></v-avatar>
                        <strong class="font-weight-medium line-height-12">{{ faq.question }}</strong>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row no-gutters>
                        <v-col cols="12" md="auto">
                            <v-avatar color="secondary" size="32" class="mb-6px mr-10px mb-md-0px"><strong class="font-size-14 white--text mt-n2px">A</strong></v-avatar>
                        </v-col>
                        <v-col cols="12" md="auto">
                            <p v-html="faq.answer?.replace?.(/\n/g, '<br>')" class="line-height-16"></p>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import api from "@/api";

export default{
    props: {
        code: { type: String, default: null },
    },
    data() {
        return {
            filter: {
                type: "회원서비스",
            },
            faqs: []
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            try{
                await this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async search(){
            try{
                var { summary, faqs } = await api.v1.center.faqs.gets({
                    params: this.filter
                });

                this.faqs = faqs;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        }
    }
}
</script>